import React, { useState } from "react";
import { Box, Button, Container, Stack } from "@mui/material";
import { MOBILE_CONTAINER } from "../../../../utils/ui.constants";
import { useOrderContext } from "../../OrderPage";
import Payment from "./payment";

function Bottom() {
  const { saveHd } = useOrderContext();
  const [openPayment, setOpenPayment] = useState<boolean>(false);

  const handleGuiBep = () => {
    saveHd(1);
  };

  return (
    <>
      <Payment open={openPayment} onClose={() => setOpenPayment(false)} />
      <Stack>
        <Box>
          <Container maxWidth={MOBILE_CONTAINER}>
            <Stack direction="row" alignItems="center">
              <Box sx={{ width: "50%" }}>
                <Button
                  onClick={handleGuiBep}
                  fullWidth
                  variant="contained"
                  color="secondary"
                  sx={{
                    height: "45px",
                    color: "common.white",
                    borderRadius: "0px",
                    boxShadow: "none",
                    "&:hover": {
                      boxShadow: "none",
                    },
                  }}
                >
                  Gửi bếp
                </Button>
              </Box>
              <Box sx={{ width: "50%" }}>
                <Button
                  onClick={() => setOpenPayment(true)}
                  fullWidth
                  variant="contained"
                  sx={{
                    height: "45px",
                    color: "common.white",
                    borderRadius: "0px",
                    boxShadow: "none",
                    "&:hover": {
                      boxShadow: "none",
                    },
                  }}
                >
                  Thanh toán
                </Button>
              </Box>
            </Stack>
          </Container>
        </Box>
      </Stack>
    </>
  );
}

export default Bottom;
